import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    ExpandedIndex,
    Text
} from "@chakra-ui/react";
import {useState} from "react";
import {Spot, SpotInfo} from "../types";
import SpotListGeneral from "./details/SpotListGeneral";
import SpotDescriptionDetails from "./details/SpotDescriptionDetails";
import SoundFilesSection from "../soundfiles/SoundFilesSection";
import SpotListTriggerList from "./details/SpotListTriggerList";
import SpotListRules from "./details/rules/SpotListRules";
import AdvancedSpotDetails from "./details/AdvancedSpotDetails";

type Props = {
    spot: Spot;
    spotsInfo: SpotInfo[];
    openSections?: ExpandedIndex;
    onOpenSectionsChange?: (index: ExpandedIndex) => void;
};

const SpotDetailsAccordion = ({spot, spotsInfo, openSections, onOpenSectionsChange}: Props) => {
    const [internalOpenSections, setInternalOpenSections] = useState<ExpandedIndex>([0]);
    const currentOpenSections = openSections ?? internalOpenSections;
    const handleChange = onOpenSectionsChange ?? setInternalOpenSections;

    return (
        <Accordion allowToggle allowMultiple={false} index={currentOpenSections} onChange={handleChange} size={"sm"} marginTop={"8px"}>
            <AccordionItem>
                <AccordionButton px={0}>
                    <Text fontWeight={"medium"}>General</Text>
                    <AccordionIcon/>
                </AccordionButton>
                <AccordionPanel pb={4}>
                    <SpotListGeneral spot={spot}/>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionButton px={0}>
                    <Text fontWeight={"medium"}>Description</Text>
                    <AccordionIcon/>
                </AccordionButton>
                <AccordionPanel pb={4}>
                    <SpotDescriptionDetails spot={spot}/>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionButton px={0}>
                    <Text fontWeight={"medium"}>Sound Files</Text>
                    <AccordionIcon/>
                </AccordionButton>
                <AccordionPanel pb={4}>
                    <SoundFilesSection spot={spot} key={"soundfiles" + spot.id}/>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionButton px={0}>
                    <Text fontWeight={"medium"}>Triggers</Text>
                    <AccordionIcon/>
                </AccordionButton>
                <AccordionPanel pb={4}>
                    <SpotListTriggerList spot={spot} key={"marker_" + spot.id}/>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionButton px={0}>
                    <Text fontWeight={"medium"}>Rules</Text>
                    <AccordionIcon/>
                </AccordionButton>
                <AccordionPanel pb={4}>
                    <SpotListRules spot={spot} key={"rules_" + spot.id} allSpotsInfo={spotsInfo}/>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionButton px={0}>
                    <Text fontWeight={"medium"}>Advanced</Text>
                    <AccordionIcon/>
                </AccordionButton>
                <AccordionPanel pb={4}>
                    <AdvancedSpotDetails spot={spot} key={"advanced" + spot.id}/>
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    );
};

export default SpotDetailsAccordion;
